import React from 'react';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { getProjectColor } from 'src/utils/BigCalendarColourGeneratorUtils';
import { IPropertyWithState, IUniqueEventType } from 'src/pages/Calendar/types';
import './colour-legend.scss';

interface ColorLegendProps {
  label: string;
  items: IPropertyWithState[] | IUniqueEventType[];
}

// Type guard to check if item is IUniqueEventType.
const isUniqueEventType = (
  item: IPropertyWithState | IUniqueEventType
): item is IUniqueEventType => {
  return 'color' in item && 'value' in item;
};

const ColorLegend = ({ label, items }: ColorLegendProps) => {
  if (items.length === 0) return null;

  return (
    <div className="colour-legend">
      <div className="tenant_pills-container">
        {items.map((item: IPropertyWithState | IUniqueEventType) => {
          let pillColor: string;
          let pillTextColor: string;
          let keyValue: string;
          let eventTypeValue: string | undefined;

          if (isUniqueEventType(item)) {
            pillColor = item.enabled ? item.color : '#e5e7eb';
            pillTextColor = item.enabled
              ? item.textColor || 'white'
              : '#9ca3af';
            keyValue = item.text;
            eventTypeValue = item.value;
          } else {
            pillColor = item.enabled ? getProjectColor(item.text) : '#e5e7eb';
            pillTextColor = item.enabled ? 'white' : '#9ca3af';
            keyValue = item.id;
            eventTypeValue = undefined;
          }

          return (
            <CategoryPill
              key={keyValue}
              text={item.text}
              color={pillColor}
              textColor={pillTextColor}
              enabled={item.enabled}
              eventType={eventTypeValue}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ColorLegend;
